import { Record } from 'immutable';
import { PartyType } from './party-type';
import { Contact } from './contact';

const PartyRecord = Record({
  eventPartyId: 0,
  version: 0,
  createDate: null,
  modifiedDate: null,
  brand: null,
  chain: null,
  propertyId: null,
  agencyId: null,
  clientReferenceNumber: null,
  partyType: null,
  code: null,
  name: null,
  dbaName: null,
  countryCode: null,
  eventId: null,
  line1: null,
  line2: null,
  line3: null,
  city: null,
  state: null,
  postalCode: null,
  eventReferenceNumber: null,
  autoGeneratedCode: null,
  manuallyAdded: null,
  contact: new Contact(),
  subscriber: null
});

export class Party extends PartyRecord {
  eventPartyId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  brand: string;
  chain: string;
  propertyId: string;
  agencyId: string;
  clientReferenceNumber: string;
  partyType: PartyType;
  code: string;
  name: string;
  dbaName: string;
  countryCode: string;
  eventId: number;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  postalCode: string;
  eventReferenceNumber: string;
  autoGeneratedCode: boolean;
  manuallyAdded: boolean;
  contact: Contact;
  subscriber: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/party.ts